export const JOURNEY_STATES222 = [
  'dormant', 'returning', 'newcomer', 'firstExplorationPending', 'familyLinkPending',
  'monthlyFinisher', 'nearGoal', 'firstWeekSettling', 'steady',
] as const;
export type JourneyState222 = (typeof JOURNEY_STATES222)[number];

export const journeyStateLabels222: Record<JourneyState222, string> = {
  newcomer: '신규 사용자',
  firstExplorationPending: '첫 탐험 미완료',
  firstWeekSettling: '첫 주 정착',
  steady: '안정 이용',
  nearGoal: '목표 달성 직전',
  dormant: '장기 미접속',
  returning: '복귀 사용자',
  familyLinkPending: '가족 연결 대기',
  monthlyFinisher: '월간 완주 사용자',
};

/** One suggested action per state. A list of chores does not help anyone return. */
export const journeyNextAction222: Record<JourneyState222, { copy: string; to: string }> = {
  newcomer: { copy: '2분 경제 탐험으로 첫 벽돌을 만들어 보세요.', to: '/today/article' },
  firstExplorationPending: { copy: '오늘의 경제 이야기가 기다리고 있어요.', to: '/today/article' },
  firstWeekSettling: { copy: '이번 주 탐험을 이어가면 마을이 조금씩 달라져요.', to: '/child/first-week' },
  steady: { copy: '이번 주 탐험 목표를 확인해 보세요.', to: '/child/weekly-expedition' },
  nearGoal: { copy: '벽돌 2개를 더 모으면 창문이 완성돼요.', to: '/village/hub' },
  dormant: { copy: '모아둔 벽돌과 퍼즐은 그대로예요. 천천히 다시 시작해요.', to: '/child/home' },
  returning: { copy: '스노우빌리지는 그대로 기다리고 있었어요.', to: '/child/home' },
  familyLinkPending: { copy: '가족과 함께하면 탐험 이야기가 더 풍성해져요.', to: '/child/family-missions' },
  monthlyFinisher: { copy: '이번 달 이야기를 완성했어요. 기억 카드를 확인해 보세요.', to: '/child/weekly-report' },
};

export const SEASONS222 = ['spring', 'summer', 'autumn', 'winter'] as const;
export type Season222 = (typeof SEASONS222)[number];
export const seasonLabels222: Record<Season222, string> = {
  spring: '봄', summer: '여름', autumn: '가을', winter: '겨울',
};

export interface RetentionMetrics222 {
  visitCount: number;
  firstExplorationCompleted: boolean;
  day1Return: boolean;
  day7Return: boolean;
  day30Return: boolean;
}

/**
 * Presentation fields only. A variant that could carry a reward quantity would
 * make experiment arms unfair, so the shape simply has nowhere to put one.
 */
export interface ExperimentVariant222 {
  key: string;
  cardOrder?: string;
  copyKey?: string;
  missionStyle?: string;
  rewardAnimation?: string;
  returnMessageKey?: string;
}

/** Absence is never shown as failure, so dormancy reads as an open door. */
export function isEncouragingState222(state: JourneyState222): boolean {
  return state === 'dormant' || state === 'returning';
}

export function retentionSummary222(metrics: RetentionMetrics222): string {
  const reached = [metrics.day1Return && '1일', metrics.day7Return && '7일', metrics.day30Return && '30일'].filter(Boolean);
  return reached.length ? `${reached.join(' · ')} 재방문` : '재방문 기록 없음';
}
